import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesSection from '../../components/feature/ServicesSection';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import { homeFaqs } from '../../mocks/faqs';

const heroContent = {
  badge: "Houston's Premier Property Solutions Provider",
  headline: 'Professional Home Improvement, Done Right.',
  subheadline: 'Fair. Honest. On Time. Guaranteed.',
  description: '16+ years of trusted home remodeling and handyman services across Houston TX and surrounding areas. We get it done right — every single time.',
  primaryCTA: { text: 'Get Your Free Quote', href: '#quote' },
  secondaryCTA: { text: 'Call 346-363-8363', href: 'tel:3463638363' },
  backgroundImage: 'https://public.readdy.ai/ai/img_res/1158e1e76ca0ebdf6b306e19c42bb24c.jpg',
  stats: [
    { value: '16+', label: 'Years in Houston' },
    { value: '5.0 ★', label: 'Google Rated' },
    { value: '60%+', label: 'Repeat Clients' },
    { value: '7 Days', label: 'A Week' },
  ],
};

const aiContent = {
  eyebrow: 'AI Answer Block',
  title: 'What is One Call Handyman Service?',
  lead: 'One Call Handyman Service is Houston\'s top-rated professional property solutions provider — serving homeowners and property managers across Houston TX and all surrounding communities for over 16 years.',
  points: [
    {
      icon: 'ri-home-gear-line',
      title: 'What We Do',
      body: 'We provide expert home remodeling and handyman services throughout Houston TX — make-ready remodeling, flooring, drywall & painting, electrical, plumbing, and roofing. One call covers it all.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Services Offered',
      body: 'Make-Ready Remodeling · Flooring Installation · Drywall & Painting · Electrical Repairs · Plumbing Services · Roofing. Every service is backed by 16+ years of Houston expertise and a satisfaction guarantee.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Who We Serve',
      body: 'Houston TX homeowners, landlords, and property managers who need reliable, professional work done right the first time. We serve Houston 77075 and all surrounding Greater Houston communities.',
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Key Benefits',
      body: 'Fair & honest pricing with no hidden fees. On-time project completion. 100% satisfaction guarantee. 60%+ repeat and referral business built on 16+ years of trust in Houston TX.',
    },
    {
      icon: 'ri-route-line',
      title: 'Our Process',
      body: 'Request a free quote → We review and explain the project in full detail → Our team arrives and gets to work immediately. Every job is completed on time and done right.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Service Area',
      body: 'Proudly serving Houston TX and surrounding areas including Pearland, Sugar Land, Katy, Baytown, Pasadena, The Woodlands, League City, Friendswood, Cypress, Spring, and many more.',
    },
  ],
};

export default function HomePage() {
  return (
    <main className="pb-16 lg:pb-0">
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesSection
        title="Professional Property Solutions"
        subtitle="Six core services. One trusted provider. All delivered with Houston-grade expertise and a 100% satisfaction guarantee."
      />
      <AIAnswerBlock content={aiContent} />
      <ProcessSection />
      <WhyChooseUs
        image="https://topratedhomepros.com/website/sites-images/handy1man/about-545x495-contractors-working.jpg"
        title="Why Houston Homeowners Choose One Call"
        subtitle="Built on 16+ years of earned trust, transparent pricing, and a commitment to doing every Houston job right the first time."
      />
      <ServiceAreasSection />
      <TestimonialsSection />
      <FAQSection
        faqs={homeFaqs}
        title="Houston Handyman Questions — Answered"
        subtitle="Voice-search and AI-ready answers to what Houston homeowners ask most about our services."
      />
      <FinalCTA
        headline="Ready to Elevate Your Houston Property?"
        subheadline="Request your free quote today. No obligation, no pressure — just honest, professional service done right."
      />
      <Footer />
    </main>
  );
}
